const hooks = {
  /**
   * Standard afterConnect that calls the component's load event
   */
  loadOnConnect: (ref) => ref?.events?.load?.(),
  /**
   * AfterConnect hook that sets up component animations
   * Delays animation initialization to ensure proper positioning
   */
  loadAnimation: (ref) => ref?.events?.loadAnimation?.(),
  /**
   * Standard resize handler for afterConnect
   */
  resizeOnConnect: (ref) => ref?.events?.resize?.()
};
const CommonLifecycleHooks = hooks;
export {
  CommonLifecycleHooks,
  hooks
};
//# sourceMappingURL=lifecycle.js.map
